<template>
    <div>
        <p class="m-t-15 font-size-16" v-if="!finished">
            {{ $t("Por favor, insira as informações para criar sua conta:") }}
        </p>
        <form @submit.prevent="addItem" ref="addItem" v-if="!finished">
            <div class="row">
                <form-select
                    v-model="item.unidade"
                    :itens="unidades"
                    :loading="loadingSearchUnidade"
                    :required="true"
                    :disabled="loadingSearchUnidade"
                    placeholder="Pesquise o nome de uma Unidade."
                    label="Unidade"
                />
                <form-input
                    grid="9"
                    v-model="item.nome"
                    :required="true"
                    label="Nome"
                />
                <form-input
                    grid="3"
                    v-model="item.cpf"
                    :required="true"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                />
                <form-input
                    grid="3"
                    label="Data de Nascimento"
                    :required="true"
                    v-model="item.data_nascimento"
                    v-mask="'##/##/####'"
                />
                <form-select
                    grid="3"
                    v-model="item.sexo"
                    :itens="$root.arrays.sexo"
                    :required="true"
                    placeholder="Selecione"
                    label="Sexo"
                />
                <form-input
                    grid="3"
                    v-model="item.telefone"
                    :required="true"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Telefone"
                />
                <form-input
                    grid="3"
                    v-model="item.whatsapp"
                    :required="true"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Whatsapp"
                />
                <form-input grid="6" v-model="item.profissao" label="Cargo"   :required="true"/>
                <form-select
                    grid="6"
                    v-model="item.escolaridade"
                    :itens="$root.arrays.tiposEscolaridadeTecnicos"
                    :required="true"
                    placeholder="Selecione"
                    label="Escolaridade"
                />
                <form-select
                    grid="6"
                    v-model="item.role"
                    :itens="roles"
                    :required="true"
                    placeholder="Selecione uma Função"
                    label="Função na Unidade/Sistema"
                />
                <form-select
                    grid="6"
                    v-model="item.regime_trabalho"
                    :required="true"
                    :itens="$root.arrays.regimeTrabalhoTecnicos"
                    placeholder="Selecione"
                    label="Regime de Trabalho"
                />

                <form-calendar
                    v-model="item.data_admissao"
                    :required="true"
                    grid="6"
                    label="Data de Vinculação"
                />

                <form-calendar
                    v-model="item.data_desviculacao"
                    grid="6"
                    label="Data de Desvinculação"
                />

                <form-select
                    grid="6"
                    v-model="item.carga_horaria"
                    :itens="$root.arrays.cargaHorariaTecnicos"
                    :required="true"
                    placeholder="Selecione"
                    label="Carga Horária"
                />

                <div class="col-md-12">
                    <h3>Dados de Acesso ao Sistema</h3>
                </div>
                <form-input
                    grid="8"
                    v-model="item.email"
                    :required="true"
                    label="E-mail"
                />

                <div class="col-md-4">
                    <b-form-group class="mb-2" label-for="password">
                        <template v-slot:label
                            >{{ $t("Senha") }}
                            <span class="text-danger">*</span></template
                        >
                        <b-input-group>
                            <b-form-input
                                :type="passwordInput"
                                id="password"
                                required
                                v-model="item.password"
                            />
                            <b-input-group-append style="height: 35px">
                                <b-button
                                    :title="$t('Show/Hide password')"
                                    @click="showPassword"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="primary"
                                >
                                    <i
                                        class="fas fa-fw fa-eye"
                                        v-if="passwordInput === 'password'"
                                    />
                                    <i class="fas fa-fw fa-eye-slash" v-else />
                                </b-button>
                                <b-button
                                    :title="$t('Generate new password')"
                                    @click="generatePassword"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="secondary"
                                >
                                    <i class="fas fa-fw fa-sync" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </div>
            </div>

            <div class="float-right mt-3">
                <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </form>
        <div v-else>
            <p class="m-t-15 font-size-16 text-danger" v-if="forbidden">
                O registro de novas contas foi bloqueado pelo administrador.
            </p>
            <p class="m-t-15 font-size-16 text-primary" v-else>
                Sua conta foi criada, aguarde até que um administrador libere
                seu acesso.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Register",
    metaInfo() {
        return {
            title: this.$i18n.t("Register"),
        };
    },
    mounted() {
        //console.log();
        this.verification();
    },
    data() {
        return {
            loading: false,
            loadingSearchUnidade: false,
            tecnicosList: [],
            localidades: [],
            localidade: {},
            logradouros: [],
            logradouro: {},
            unidades: [],
            passwordInput: "password",
            item: {
                password: null,
            },
            settings: {},
            roles: [],
            finished: false,
            forbidden: false,
        };
    },
    methods: {
        verification() {
            //console.log(window.config.registration_to_display);
            if (window.config.registration_to_display) {
                this.getUnidades();
                this.getRoles();
            } else {
                this.finished = true;
                this.forbidden = true;
                setTimeout(() => {
                    this.$router.push("/auth/login");
                    this.$parent.isRegister = false;
                }, 3000);
            }
        },
        addItem() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            // if (this.item.data_admissao) {
            // 	this.item.data_admissao = moment(this.item.data_admissao, "YYYY-MM-DD").format(
            // 		"YYYY-MM-DD"
            // 	);
            // }

            // Send request
            axios.post("api/auth/register", this.item).then((response) => {
                ladda.stop();
                this.finished = true;
            });
        },
        // Show the password input
        showPassword() {
            if (this.passwordInput === "password") {
                this.passwordInput = "text";
            } else {
                this.passwordInput = "password";
            }
        },
        // Generate new password
        generatePassword() {
            this.item.password = window.GeneratePassword.generate({
                length: 8,
                numbers: true,
                symbols: false,
                excludeSimilarCharacters: true,
                strict: true,
            });
        },
        getRoles() {
            // Get all settings values
            axios.get("users/roles").then((response) => {
                this.roles = response.data.map(item=>{
                    if(item.value != "User")
                    {
                        return {id:item.id,value:item.value}
                    }
                }).filter(item=>item != undefined);
                // this.roles = response.data.data;
                this.loading = false;
            });
        },

        getUnidades() {
            this.loadingSearchUnidade = true;
            axios
                .get(`unidades/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => (this.loadingSearchUnidade = false));
        },
    },
};
</script>
